import React from "react";
import { useGoogleLogin } from "@react-oauth/google";
import Api from "../services/apis/setup";
import { useNavigate } from "react-router";
import { Button, Box } from "@mui/material";

const GoogleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="24" width="24"><path fill="#4285f4" d="M386 400c45-42 65-112 53-179H260v74h102c-4 24-18 44-38 57z"></path><path fill="#34a853" d="M90 341a192 192 0 0 0 296 59l-62-48c-53 35-141 22-171-60z"></path><path fill="#fbbc02" d="M153 292c-8-25-8-48 0-73l-63-49c-23 46-30 111 0 171z"></path><path fill="#ea4335" d="M153 219c22-69 116-109 179-50l55-54c-78-75-230-72-297 55z"></path></svg>
);
export default function GoogleLoginButton() {
  const [login] = Api.useGoogleLoginMutation();
  const navigate = useNavigate();

  const googleLogin = useGoogleLogin({
    onSuccess: async (credentialResponse) => {
        console.debug("Google credential response", credentialResponse);
        await login({
          baseURL: "/auth/google",
          payload: JSON.stringify({ token: credentialResponse.access_token }),
          arguments: { token: credentialResponse.access_token },
        });
        navigate("/");
    },
    onError: () => console.error("Google Login Failed"),
    flow: "implicit", // or "auth-code" depending on your backend
  });

  return (
    <Box display="flex" justifyContent="center">
      <Button
        variant="contained"
        startIcon={<GoogleIcon />}
        onClick={() => googleLogin()}
        sx={{
          textTransform: "none", // keep text as "Continue with Google"
          backgroundColor: "white",
          color: "black"
        }}
      >
        Continue with Google
      </Button>
    </Box>
  );
}

// import { GoogleLogin } from "@react-oauth/google";
// import { useNavigate } from "react-router-dom";
// import Api from "../services/apis/setup";

// export default function GoogleLoginButton() {
//   const [login] = Api.useGoogleLoginMutation();
//   const navigate = useNavigate();

//   return (
//     <GoogleLogin
//       onSuccess={async (credentialResponse) => {
//         console.log("Google credential response", credentialResponse);
//         // credentialResponse.credential is the ID token (JWT)
//         await login({
//           baseURL: "/auth/google",
//           payload: { token: credentialResponse.credential },
//           arguments: { token: credentialResponse.credential },
//         });
//         navigate("/");
//       }}
//       onError={() => console.error("Google Login Failed")}
//       render={(renderProps: any) => (
//         <button
//           onClick={renderProps.onClick}
//           disabled={renderProps.disabled}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             padding: "10px 20px",
//             backgroundColor: "white",
//             color: "black",
//             border: "none",
//             borderRadius: "4px",
//             cursor: "pointer",
//             fontSize: "16px",
//           }}
//         >
//           Continue with Google
//         </button>
//       )}
//     />
//   );
// }